import React, { useState, useEffect } from 'react'
import { Bar, Pie } from 'react-chartjs-2';
import AdminHomeHelper from '../../Components/AdminHomeHelper'
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, ArcElement, Title, Tooltip, Legend } from 'chart.js';
ChartJS.register(CategoryScale, LinearScale, BarElement, ArcElement, Title, Tooltip, Legend);


const AdminTransport = () => {

  const feeData = {
    labels: ['ARJCET', 'ARJMS', 'ARJPOLY', 'ARJSchool'],
    datasets: [
      {
        label: 'Collected Fee',
        data: [1501020112, 32464755, 49057225, 7110910],
        backgroundColor: 'rgba(75, 192, 192, 0.6)',
        borderColor: 'rgba(75, 192, 192, 1)',
        borderWidth: 1,
      },
      {
        label: 'Pending Fee',
        data: [117236314, 1379455, 84105617, 7553100],
        backgroundColor: 'rgba(255, 99, 132, 0.6)',
        borderColor: 'rgba(255, 99, 132, 1)',
        borderWidth: 1,
      },
    ],
  };

  // Pie chart data for Faculties
  const facultyData = {
    labels: ['ARJ College of Eng & Tech', 'ARJ Institute of Mgmt', 'ARJ Polytechnic', 'ARJ Public Sr Sec School'],
    datasets: [
      {
        label: 'Teaching Faculty',
        data: [221, 25, 154, 11],
        backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0'],
      },
      {
        label: 'Non-Teaching Faculty',
        data: [19, 4, 26, 434],
        backgroundColor: ['#FF9F40', '#FF6384', '#36A2EB', '#FFCE56'],
      },
    ],
  };

  return (
    <div>
      <div className="container-fluid p-0">
        <div className="d-flex">
          <div className="print-helper">
            <AdminHomeHelper />
          </div>
          <div className="mx-1 w-100 ">
            <div className='px-3 py-1 bg-light d-flex align-items-center justify-content-between'>
              <h3> <img src="/logo192.png" width={'50px'} alt="" /> Academic Statistics</h3>
              <button onClick={() => window.print()} type="button" className=" btn-success btn text-light"> <img src="/image/print.svg" lt="" /> Download</button>
            </div>
            <div>
              <h3>Fees Collection</h3>
              <div className="row">
                <div className='col-7'>
                  <Bar data={feeData} options={{ responsive: true, plugins: { legend: { position: 'top' }, title: { display: true, text: 'Fee Collection Overview' } } }} />

                </div>
                <div className="col-5">
                  <Pie data={facultyData} options={{ responsive: true, plugins: { legend: { position: 'top' }, title: { display: true, text: 'Teaching vs Non-Teaching Faculty' } } }} />

                </div>
              </div>

              <table className="table table-bordered table-striped" border="1">
                <thead className="thead-dark" >
                  <tr>
                    <th>#</th>
                    <th>Institution Name</th>
                    <th>Departments</th>
                    <th>Courses</th>
                    <th>Students</th>
                    <th>Discontinued</th>
                    <th>Long Absent</th>
                    <th>Total Fee</th>
                    <th>Collected Fee</th>
                    <th>Pending Fee</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>ARJ College of Engineering and Technology</td>
                    <td>8</td>
                    <td>37</td>
                    <td>1,157</td>
                    <td>51</td>
                    <td>6</td>
                    <td>52,065,000</td>
                    <td>45,568,346</td>
                    <td>6,496,654</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>ARJ Institute of Management Studies</td>
                    <td>2</td>
                    <td>4</td>
                    <td>256</td>
                    <td>4</td>
                    <td>1</td>
                    <td>11,520,000</td>
                    <td>9,052,945</td>
                    <td>2,467,055</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>A.R.J Polytechnic College</td>
                    <td>8</td>
                    <td>10</td>
                    <td>750</td>
                    <td>7</td>
                    <td>3</td>
                    <td>33,750,000</td>
                    <td>24,057,225</td>
                    <td>9,693,000</td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>A.R.J Public Senior Secondary School</td>
                    <td>9</td>
                    <td>0</td>
                    <td>325</td>
                    <td>0</td>
                    <td>0</td>
                    <td>7,553,100</td>
                    <td>7,110,910</td>
                    <td>442,190</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td colSpan="2">Grand Total</td>
                    <td>27</td>
                    <td>51</td>
                    <td>2,488</td>
                    <td>62</td>
                    <td>10</td>
                    <td>104,888,100</td>
                    <td>85,789,426</td>
                    <td>19,098,899</td>
                  </tr>
                </tfoot>
              </table>

              <h3>Faculties</h3>


              <table className="table table-bordered table-striped" border="1">
                <thead className="thead-dark">
                  <tr>
                    <th>#</th>
                    <th>Institution Name</th>
                    <th>Departments</th>
                    <th>Faculties</th>
                    <th>Teaching Faculties</th>
                    <th>Non Teaching Faculty</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>ARJ College of Engineering and Technology</td>
                    <td>32</td>
                    <td>240</td>
                    <td>221</td>
                    <td>19</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>ARJ Institute of Management Studies</td>
                    <td>4</td>
                    <td>29</td>
                    <td>25</td>
                    <td>4</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>A.R.J Polytechnic College</td>
                    <td>21</td>
                    <td>180</td>
                    <td>154</td>
                    <td>26</td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>A.R.J Public Senior Secondary School</td>
                    <td>9</td>
                    <td>445</td>
                    <td>11</td>
                    <td>434</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td colSpan="2">Grand Total</td>
                    <td>67</td>
                    <td>894</td>
                    <td>411</td>
                    <td>493</td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AdminTransport
